import RMButton from 'components/customComponents/Controls/RMButton';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { showAlertSnackBar } from 'utils/Global';
import ImportSynchTripWizardContext from './importSynchTripWizardContext';
import { IStyle } from 'Styles';
import { csvColumnHeadings } from '../utils';

const validateImportCSV = (dataArray) => {
  if (
    !dataArray?.length ||
    dataArray?.length <= 1 ||
    !dataArray[0]?.length ||
    dataArray[0].length != 9
  ) {
    return false;
  }
  const headerRow = dataArray[0];
  if (
    !(
      headerRow[0] === csvColumnHeadings.synchTripId &&
      headerRow[1] === csvColumnHeadings.synchTripName &&
      headerRow[2] === csvColumnHeadings.dataCollectionDate &&
      headerRow[3] === csvColumnHeadings.crystalId &&
      headerRow[4] === csvColumnHeadings.crystalName &&
      headerRow[5] === csvColumnHeadings.puckName &&
      headerRow[6] === csvColumnHeadings.puckPinPosition &&
      headerRow[7] === csvColumnHeadings.dewarId &&
      headerRow[8] === csvColumnHeadings.dewarName
    )
  ) {
    return false;
  }

  return true;
};

const FileUploadPage = () => {
  const inputFile = useRef(null);
  const synchTripContext = useContext(ImportSynchTripWizardContext);
  const [fileLabel, setFileLabel] = useState('Select File .csv');

  useEffect(() => {
    synchTripContext.setNextButtonDisallowed(true);
  }, []);

  let reader;
  function fileChangedHandler(e) {
    const file: File = e.target.files[0];
    if (file) {
      const fileName = file.name.toLowerCase();
      const fileType = file.type;
      if (
        fileName.endsWith('.csv') ||
        fileType === 'text/csv' ||
        fileType === 'application/vnd.ms-excel'
      ) {
        reader = new FileReader();
        reader.onloadend = handleFileRead;
        reader.readAsText(file);
        setFileLabel(file.name);
      } else {
        showAlertSnackBar(
          EAlertType.ERROR,
          ESnackBarPosition.TOP,
          'Input file is not a CSV file.',
        );
      }
    }
  }

  async function handleFileRead(e) {
    const fileContent = reader.result;
    const dataArray = fileContent.split('\r\n').map((line) => line.split(','));
    const validDataArray = dataArray.filter((row) => row?.length > 1);
    if (!validateImportCSV(validDataArray)) {
      showAlertSnackBar(
        EAlertType.ERROR,
        ESnackBarPosition.TOP,
        'Input file is not in correct format.',
      );
      return;
    }
    validDataArray.splice(0, 1); //remove first row
    synchTripContext.setFileContent(validDataArray);
    synchTripContext.setNextButtonDisallowed(false);
  }

  const onChooseFile = () => {
    inputFile.current.click();
  };
  return (
    <div
      id="fileuploadpage-wrapper"
      className="flex flex-xy-center flex-column"
      style={styles.uploadHeading}
    >
      <div id="fileuploadpage-label">
        <label id="fileuploadpage-label-text">{fileLabel}</label>
      </div>
      <div id="fileuploadpage-browsefile-button">
        <RMButton
          id='fileuploadpage-browse-button'
          customStyle={styles.browseButton}
          onClick={onChooseFile}
          label="Browse File"
        />
      </div>
      <div id="fileuploadpage-file">
        <input
          id="fileuploadpage-file-input"
          type="file"
          ref={inputFile}
          style={{ display: 'none' }}
          onChange={fileChangedHandler}
        />
      </div>
      <div id="fileuploadpage-message" style={styles.browseText}>
        {`Please select "Browse File" to import .csv file`}
      </div>
    </div>
  );
};

export default FileUploadPage;

const styles: IStyle = {
  buttonRoot: {
    margin: '10px 0px 0px 0px',
  },
  browseButton: {
    width: '12rem',
    height: '2rem',
    maxHeight: '2rem',
    minHeight: '2rem',
    borderRadius: '0.5rem',
    fontSize: '1.25rem',
    lineHeight: '1.45rem',
    textTransform: 'none',
  },
  browseText: {
    textAlign: 'center',
    color: 'gainsboro',
  },
  uploadHeading: {
    height: '100%',
  },
};
